import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
var BeforeAfterImages = function BeforeAfterImages() {
  return import('~/components/molecules/Editorial/BeforeAfterEffect/BeforeAfterImages.vue');
};
export default {
  name: 'Slide',
  components: {
    BeforeAfterImages: BeforeAfterImages,
    RegularTitle: RegularTitle,
    SimpleParagraph: SimpleParagraph
  },
  props: {
    avatar: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    avatarTitle: {
      type: String,
      default: ''
    },
    avatarSubtitle: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    tag1: {
      type: String,
      default: ''
    },
    tag2: {
      type: String,
      default: ''
    },
    title: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    description: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cta: {
      type: String,
      default: ''
    },
    ctaTheme: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    imageBefore: {
      type: Object,
      default: null
    },
    imageAfter: {
      type: Object,
      default: null
    },
    tracking: {
      type: Object,
      default: null
    },
    labelImageBefore: {
      type: String,
      default: ''
    },
    labelImageAfter: {
      type: String,
      default: ''
    }
  },
  computed: {
    ctaClasses: function ctaClasses() {
      if (this.ctaTheme === 'link') return ['btn-link', 'btn-link-u'];
      var btnTheme = this.ctaTheme === 'primary' ? 'dark' : 'light';
      return ['btn', "btn-".concat(btnTheme)];
    },
    hasBeforeAfterEffect: function hasBeforeAfterEffect() {
      return !!(this.imageBefore && this.imageAfter);
    }
  },
  methods: {
    onClick: function onClick(evt) {
      var _this$tracking, _this$tracking2, _this$tracking3;
      this.$root.$emit('generic-tracking', evt, {
        data: {
          event_category: (_this$tracking = this.tracking) === null || _this$tracking === void 0 ? void 0 : _this$tracking.event_category,
          event_action: (_this$tracking2 = this.tracking) === null || _this$tracking2 === void 0 ? void 0 : _this$tracking2.event_action,
          event_label: (_this$tracking3 = this.tracking) === null || _this$tracking3 === void 0 ? void 0 : _this$tracking3.event_label
        }
      });
    }
  }
};